import BaseService from './Base';

class PropertyOptions extends BaseService {
  static endpoint = 'api/2.0/field-subgroups/';
}

export default PropertyOptions;